import { render, staticRenderFns } from "./Arrow.vue?vue&type=template&id=20ebab54&scoped=true"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"
import style0 from "./Arrow.vue?vue&type=style&index=0&id=20ebab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebab54",
  null
  
)

export default component.exports